// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__ZKOIP","rotate":"Loader_rotate__beEiN","visible":"Loader_visible__UKgK0","load":"Loader_load__LVaAv"};